module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }